/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainThreatThreatTypeEnum } from './DomainThreatThreatTypeEnum';
import {
    DomainThreatThreatTypeEnumFromJSON,
    DomainThreatThreatTypeEnumFromJSONTyped,
    DomainThreatThreatTypeEnumToJSON,
    DomainThreatThreatTypeEnumToJSONTyped,
} from './DomainThreatThreatTypeEnum';
import type { Status7f3Enum } from './Status7f3Enum';
import {
    Status7f3EnumFromJSON,
    Status7f3EnumFromJSONTyped,
    Status7f3EnumToJSON,
    Status7f3EnumToJSONTyped,
} from './Status7f3Enum';
import type { TakedownEvent } from './TakedownEvent';
import {
    TakedownEventFromJSON,
    TakedownEventFromJSONTyped,
    TakedownEventToJSON,
    TakedownEventToJSONTyped,
} from './TakedownEvent';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';

/**
 * 
 * @export
 * @interface DomainThreat
 */
export interface DomainThreat {
    /**
     * 
     * @type {number}
     * @memberof DomainThreat
     */
    readonly id: number;
    /**
     * The potentially malicious domain name
     * @type {string}
     * @memberof DomainThreat
     */
    threatDomain: string;
    /**
     * Type of domain-based threat
     * 
     * * `typosquatting` - Typosquatting
     * * `brand_infringement` - Brand Infringement
     * * `phishing` - Phishing Domains
     * @type {DomainThreatThreatTypeEnum}
     * @memberof DomainThreat
     */
    threatType: DomainThreatThreatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainThreat
     */
    readonly threatTypeDisplay: string;
    /**
     * Source where the threat was detected
     * @type {string}
     * @memberof DomainThreat
     */
    source: string;
    /**
     * 
     * @type {Domain}
     * @memberof DomainThreat
     */
    readonly affectedDomain: Domain;
    /**
     * 
     * @type {number}
     * @memberof DomainThreat
     */
    affectedDomainId: number;
    /**
     * Current status of the threat investigation
     * 
     * * `new` - New
     * * `detected` - Detected
     * * `investigating` - Investigating
     * * `reported` - Reported
     * * `takendown` - Taken Down
     * @type {Status7f3Enum}
     * @memberof DomainThreat
     */
    status?: Status7f3Enum;
    /**
     * 
     * @type {string}
     * @memberof DomainThreat
     */
    readonly statusDisplay: string;
    /**
     * Confidence level from 0-100%, null indicates Unknown
     * @type {number}
     * @memberof DomainThreat
     */
    confidenceLevel?: number | null;
    /**
     * Screenshot of the threatening domain
     * @type {string}
     * @memberof DomainThreat
     */
    screenshot?: string | null;
    /**
     * Detailed description of the threat
     * @type {string}
     * @memberof DomainThreat
     */
    description?: string;
    /**
     * 
     * @type {Array<TakedownEvent>}
     * @memberof DomainThreat
     */
    readonly takedownEvents: Array<TakedownEvent>;
    /**
     * 
     * @type {Date}
     * @memberof DomainThreat
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DomainThreat
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the DomainThreat interface.
 */
export function instanceOfDomainThreat(value: object): value is DomainThreat {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('threatDomain' in value) || value['threatDomain'] === undefined) return false;
    if (!('threatType' in value) || value['threatType'] === undefined) return false;
    if (!('threatTypeDisplay' in value) || value['threatTypeDisplay'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('affectedDomain' in value) || value['affectedDomain'] === undefined) return false;
    if (!('affectedDomainId' in value) || value['affectedDomainId'] === undefined) return false;
    if (!('statusDisplay' in value) || value['statusDisplay'] === undefined) return false;
    if (!('takedownEvents' in value) || value['takedownEvents'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DomainThreatFromJSON(json: any): DomainThreat {
    return DomainThreatFromJSONTyped(json, false);
}

export function DomainThreatFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainThreat {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'threatDomain': json['threat_domain'],
        'threatType': DomainThreatThreatTypeEnumFromJSON(json['threat_type']),
        'threatTypeDisplay': json['threat_type_display'],
        'source': json['source'],
        'affectedDomain': DomainFromJSON(json['affected_domain']),
        'affectedDomainId': json['affected_domain_id'],
        'status': json['status'] == null ? undefined : Status7f3EnumFromJSON(json['status']),
        'statusDisplay': json['status_display'],
        'confidenceLevel': json['confidence_level'] == null ? undefined : json['confidence_level'],
        'screenshot': json['screenshot'] == null ? undefined : json['screenshot'],
        'description': json['description'] == null ? undefined : json['description'],
        'takedownEvents': ((json['takedown_events'] as Array<any>).map(TakedownEventFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function DomainThreatToJSON(json: any): DomainThreat {
      return DomainThreatToJSONTyped(json, false);
  }

  export function DomainThreatToJSONTyped(value?: Omit<DomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threat_domain': value['threatDomain'],
        'threat_type': DomainThreatThreatTypeEnumToJSON(value['threatType']),
        'source': value['source'],
        'affected_domain_id': value['affectedDomainId'],
        'status': Status7f3EnumToJSON(value['status']),
        'confidence_level': value['confidenceLevel'],
        'screenshot': value['screenshot'],
        'description': value['description'],
    };
}

